/* eslint-disable */
import detectionApk from './reducer/detectionReducer';

export default {
  detectionApk,
};
